// extracted by mini-css-extract-plugin
module.exports = {"container":"pageLayout_container__2DG81","wrapper":"pageLayout_wrapper__3sIeO"};